import { SellerApiInsales as SellerApiInsalesComponent } from 'components/sellers/SellerApiInsales/SellerApiInsales'
import { useParams } from 'react-router-dom'

export const SellerApiInsales: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <SellerApiInsalesComponent type='seller' sellerId={id as string} />
}
